import { useCallback, useState } from "react";
import { queryBrands } from "./requests";

export const useSearchBrands = () => {
  const [brands, setBrands] = useState([]);
  const getBrands = useCallback(async (search) => {
    if (!search) {
      setBrands([]);
      return;
    }
    try {
      const response = await queryBrands({ keywords: search });
      setBrands(response);
    } catch (error) {
      setBrands([]);
    }
  }, []);

  const getFirstSearch = async (search) => {
    const response = await queryBrands({ keywords: search });
    return response?.length ? response[0] : null;
  };
  return {
    getBrands,
    getFirstSearch,
    brands
  };
};
